/* Created by Interactive 63 - https://interactive63.com */
/**
 * The Interactive 63 logo as an inline SVG, so it takes its colour from the surrounding text and
 * follows the theme and the chosen accent.
 */
import logoSource from '../../assets/interactive63-logo.svg?raw';

const LOGO_FILL = /#FAF3DD/gi;

/** A fresh copy of the logo, sized by CSS and hidden from screen readers (the link names it). */
export function studioLogo(): SVGSVGElement {
  const holder = document.createElement('template');
  holder.innerHTML = logoSource.replace(LOGO_FILL, 'currentColor').trim();
  const svg = holder.content.firstElementChild;
  if (!(svg instanceof SVGSVGElement)) throw new Error('The studio logo could not be read.');
  svg.removeAttribute('width');
  svg.removeAttribute('height');
  svg.setAttribute('class', 'studio-logo');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  return svg;
}
